<template>
  <div class="bg-[#060608]">
    <PebbleWebsiteNavbar v-if="showNav" />
    <main
      class="relative min-h-screen w-full flex items-center justify-center p-6 overflow-hidden font-sans antialiased"
    >
        <!-- <PebbleAppHomeLogo /> -->
        <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  showNav: {
    type: Boolean,
    default: false,
  }
})
</script>
